<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.notify_title" placeholder="请输入通知标题" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="courseName" label="课程名称" width="170"></el-table-column>
            <el-table-column prop="questionTypeName" label="题目类型" width="90"></el-table-column>
            <el-table-column prop="questionName" label="题目标题"></el-table-column>
            <el-table-column label="创建时间" width="160">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.questionDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="questionImage" label="问题图片" width="120">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="img" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.questionImage)" :initial-index="index"
                        v-for="(img, index) in getThumbImageSrcList(scope.row.questionImage)"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="50%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="选择商品">
                        <el-select v-model="handleInfo.productId" placeholder="请选择" style="width: 100%;" @change="getCourses">
                            <el-option v-for="item in products" :key="item.productId" :label="item.productName" :value="item.productId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择课程">
                        <el-select v-model="handleInfo.courseId" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in courses" :key="item.courseId" :label="item.courseName" :value="item.courseId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="题目类型">
                        <el-select v-model="handleInfo.questionType" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="问题名称">
                        <el-input type="textarea" v-model="handleInfo.questionName" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item label="问题选项" v-if="handleInfo.questionType == 1 || handleInfo.questionType == 2">
                        <el-input type="textarea" v-model="handleInfo.questionChoices" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item label="问题答案">
                        <el-input type="textarea" v-model="handleInfo.questionResult" :rows="3"></el-input>
                    </el-form-item>
                    <el-form-item label="问题图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('questionImage')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('questionImage', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'questionImage' }" accept=".jpg,.jpeg,.bmp,.png"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            types: [
                {
                    label: "单选题",
                    value: 1
                },
                {
                    label: "多选题",
                    value: 2
                },
                {
                    label: "填空题",
                    value: 3
                },
                {
                    label: "简答题",
                    value: 4
                },
            ],
            products: [],
            courses: [],
        }
    },
    methods: {
        getData: async function() {
            this.products = await doGet(API.ALL.PRODUCT);
            this.initialData();
        },
        getCourses: async function(productId) {
            this.courses = await doGet(API.ALL.COURSE, {
                product_id: productId
            });
        },
        beforeHandleOpenEx: function(handle) {
            if (handle == "update") {
                this.getCourses(this.handleInfo.productId);
            }
        }
    },
    created: async function () {
        this.uploads.push({
            column: "questionImage",
            files: []
        });
        this.tag = "QUESTION";
        this.getData();
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>